/**
 * 그룹 수강 레벨 객체
 */
export default class BaseLevelListObject {
  constructor() {
    this.idxLeSugangGroupLang = 0;
    this.idxLeSugangGroupLevel = 0;
    this.levelName = "";
    this.sugangGroupClassList = new Array();
    this.staffIdx = 0;
    this.sortOrder = 0; // [2024-12-24] 레벨 정렬 순서
  }
}
